export const UnauthorizedPagePaths = [
    '/remote/inspection',
    '/generate/pnumber',
    '/public/dashboard/property/:propertyId',
    '/public/properties/:propertyId/solutions/:solutionId/dashboard'
] as const;

export type UnauthorizedPagePath = (typeof UnauthorizedPagePaths)[number];
